import { render } from "./ModalCreateTicket.vue?vue&type=template&id=88eb6d64"
import script from "./ModalCreateTicket.vue?vue&type=script&lang=js"
export * from "./ModalCreateTicket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__